module.exports = __webpack_public_path__ + "92b9fc335c102a76d80ab4a6de437927.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/cities-countries/Rome1.jpg
// module id = 3331
// module chunks = 0